module.exports = __webpack_public_path__ + "static/media/layout.749b47e3.svg";